import { observable, makeObservable, computed } from 'mobx';

import { EntityList, entityList } from '@vromo/models';
import { createModelSchema, primitive, object } from 'serializr';
import { PolicyRule } from '@vromo/models';
import { optional } from '@vromo/models';
import { PolicyCapacity } from '@vromo/models';

class IdEntity {
    id?: number | null = null;
}

createModelSchema(IdEntity, {
    id: optional(primitive()),
});

export class Policy {
    id: number | null = null;
    created: number | null = null;

    name: string | null = null;
    mode: string | null = 'assign';
    group: number | null = null;

    rules: EntityList<PolicyRule> | null = null;

    blueprints: EntityList<IdEntity> | null = null;
    sites: EntityList<IdEntity> | null = null;

    capacity?: PolicyCapacity;

    get hasSites(): boolean {
        return !!this.sites && this.sites?.items.length > 0;
    }

    get hasBlueprints(): boolean {
        return !!this.blueprints && this.blueprints?.items.length > 0;
    }

    get isInUse(): boolean {
        return this.hasSites || this.hasBlueprints;
    }

    constructor(id?: number) {
        makeObservable(this, {
            id: observable,
            name: observable,
            mode: observable,
            group: observable,
            rules: observable,
            blueprints: observable,
            sites: observable,
            capacity: observable,
            hasSites: computed,
            hasBlueprints: computed,
            isInUse: computed,
        });

        if (id) this.id = id;
    }
}

createModelSchema(Policy, {
    id: optional(primitive()),
    created: optional(primitive()),
    name: optional(primitive()),
    mode: optional(primitive()),
    group: optional(primitive()),
    rules: optional(entityList(PolicyRule)),
    blueprints: optional(entityList(IdEntity)),
    sites: optional(entityList(IdEntity)),
    capacity: optional(object(PolicyCapacity))
});
